import React from "react";
import {
	Avatar,
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	ListItem,
	Text,
	UnorderedList,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const VC101Blog: React.FC = () => (
	<>
		<Flex
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height="100%"
			py={{ xs: "30px", sm: "40px", md: "60px", lg: "80px" }}
			h="100%"
			minH={{ xs: "400px", lg: "400px" }}
			maxH={{ xs: "400px", lg: "400px" }}
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/webp/theContext-bg.webp"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir={{ xs: "column", md: "row" }}
				columnGap="24px"
				rowGap="30px"
				alignItems={{ xs: "flex-start", md: "flex-start" }}
				px={{ xs: "14px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Flex flexDir="column" rowGap="16px">
					<Heading
						color="white"
						fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
						fontWeight="800"
						lineHeight={{ xs: "35px", lg: "83px" }}
					>
						#TheContext
					</Heading>
					{/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
				</Flex>
				<Box
					w="1.5px"
					h={{ md: "200px", lg: "300px", xl: "230px" }}
					bgColor="white"
					display={{ xs: "none", md: "block" }}
				/>
				<Box
					w={{ xs: "70%", sm: "60%" }}
					h="1.5px"
					bgColor="white"
					display={{ xs: "block", md: "none" }}
				/>
				<Flex flexDir="column" rowGap="8px">
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						Level Up Your Fund Management EX with #VC101
					</Heading>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Amit Pandey
					</Text>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Sunitha Prasad
					</Text>
				</Flex>
			</Container>
		</Flex>
		<Container maxW="container.xl" pb="80px" pt="40px">
			<Flex
				flexDir={{ xs: "column-reverse", md: "row" }}
				px={{ xs: "8px", md: "0px" }}
			>
				<Flex
					w={{ xs: "100%", md: "27%" }}
					mt={{ xs: "32px", md: "0px" }}
					flexDir="column"
					rowGap="16px"
					mr={{ xs: "0px", md: "40px" }}
					ml={{ xs: "0px", sm: "10px" }}
					mb={{ xs: "16px", md: "8px" }}
				>
					<Heading
						fontSize="22px"
						lineHeight="22px"
						textAlign={{ xs: "center", sm: "left" }}
					>
						Follow the Authors
					</Heading>
					<Box
						w="100%"
						h="1.5px"
						bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
						my="8px"
					/>
					{[
						{
							name: "Amit Pandey",
							position: "Vice President, IVCA",
							linkedin: "https://www.linkedin.com/in/amitpandey2012",
							image:
								"https://static.levocdn.com/WGLBUT82/6993102139971719039.jpg",
						},
						{
							name: "Sunitha Prasad",
							position: "Vice President, IVCA",
							linkedin: "https://www.linkedin.com/in/sunitha-prasad-73a9b09/",
							image:
								"https://static.levocdn.com/WGLBUT82/6993101868986119948.png",
						},
					].map((item, index) => (
						<Flex
							key={index}
							flexDir={{ xs: "column", sm: "row", md: "column" }}
							columnGap="20px"
							rowGap="16px"
						>
							<Flex
								flexDir="column"
								alignItems={{ xs: "center", sm: "flex-start" }}
								rowGap="8px"
							>
								<Box boxSize="95px" borderRadius="50%" overflow="hidden">
									<Avatar
										name={item.name}
										w="100%"
										h="100%"
										src={item.image}
										objectFit="cover"
									/>
								</Box>
								<Flex flexDir="column" rowGap="4px">
									<Heading
										variant="blogQuestion"
										textAlign={{ xs: "center", sm: "left" }}
									>
										{item.name}
									</Heading>
									<Text
										variant="blogAnswer"
										textAlign={{ xs: "center", sm: "left" }}
										fontStyle="italic"
									>
										{item.position}
									</Text>
								</Flex>
								<Flex
									columnGap={{ xs: "4px", md: "16px" }}
									justifyContent={{ xs: "center", sm: "flex-start" }}
									transform={{ xs: "translateX(12px)", sm: "none" }}
								>
									<Box alignSelf="center">
										<Link href={item.linkedin} target="_blank">
											<IconButton
												aria-label="linkedin"
												icon={
													<FaLinkedin
														size="28px"
														color="rgba(100, 100, 140, 0.6)"
													/>
												}
												variant="unstyled"
												cursor="pointer"
											/>
										</Link>
									</Box>
								</Flex>
							</Flex>
						</Flex>
					))}
				</Flex>

				<Box w={{ xs: "100%", md: "73%" }}>
					<Text variant="blogAnswer" mb="20px">
						Ask any first-time fund manager (FTFM) about the journey of
						kick-starting a venture fund and most likely than not, this
						experience will be equated to opening an asset management start-up.
						Not to forget, FTFMs operating in the PE/VC space essentially have
						two jobs – being an investor and a business owner. Hence, this group
						of fund managers which is investing into the most risky of
						businesses need to have a 360 degree understanding of this journey
						from day zero.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						With more LPs, UHNIs and family offices turning to invest in
						alternatives with India still being a bright spot, has resulted in
						the emergence of a new crop of micro-VCs across the spectrum as they
						continue to bridge funding gaps at pre-seed and seed rounds. The
						recent Venture Capital Report by Bain & Co. in collaboration with
						IVCA, highlights India to being home to {">"} 80 micro-VCs with
						FTFMs typically managing a fund size anywhere between $10–$60M.
						Investing activities keep picking up as thematic micro-VCs and
						women-founder focused funds are on the rise as well.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Opportunities galore for sure, but so are the challenges. One such
						challenge is that the majority of these funds are led by FTFMs who
						find raising capital to networking with LPs, building a team and
						other key activities quite challenging in the formative years of
						their fund. Therefore, keeping in mind the influx of FTFMs and rise
						in the number of new venture funds, it has become imperative to
						empower them with knowledge and tools. Moreover, private investing
						in India is at a nascent stage, making it a dynamic field which
						attracts a lot of regulatory interest. In response to this latent
						demand and to strengthen the environment for venture capital in
						India, IVCA created #VC101 – a one-of-a-kind learning programme
						along with PwC and IC Universal legal as the Knowledge Partners for
						emerging venture fund managers. Sharing some key highpoints of the
						programme if you are a first time fund manager or manager at a micro
						VC fund, CIO at an active Family Office or a CVC and want to put
						this summer into use for levelling up your fund management
						experience with #VC101.
					</Text>
					<UnorderedList>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Curated by Investors for the NextGen
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							#VC101 is the brainchild of the venture capital wing of IVCA, a
							not-for-profit, apex industry body promoting alternate capital
							industry and highly committed to the development of India as a
							leading fund management hub in the world. By virtue of being an
							industry body, IVCA has access to advocacy discussions with the
							Government of India, policymakers, and regulators which have
							resulted in the rise of entrepreneurial activity, innovation, and
							job creation in India. This learning programme is a testament
							towards this commitment.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Learn from the Best in Venture Capital
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							Your search stops here, if you are keen to learn from the who’s
							who of the private capital market. #VC101 has roped in industry
							experts from IVCA’s VC Council which is chaired by Rajan Anandan
							(Managing Director, Surge & Sequoia Capital India LLP) and
							co-chaired by Rahul Khanna (Co-Founder and Managing Partner,
							Trifecta Capital). Along with them there will be other seasoned
							VCs and industry leaders with more than 70 years of combined
							experience in venture capital in India and internationally.
							Speakers will be of other diverse backgrounds and experiences,
							like GPs, LPs, Family Office veterans, Government of India leads.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Build your Network
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							Besides learning and sharpening one’s knowledge, the plan with
							#VC101 is to offer all participants a platform to network, give
							access to people and resources necessary to foster key
							relationships with peers, mentors and special invitees from the
							government/regulatory bodies and advisors.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Break away from the virtual Inertia{" "}
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							While the pandemic may have made us comfortable with Zoom
							meetings, the experience of in-person learning, hands-on training
							and the opportunity to interact with prominent faces from the VC
							world is unparalleled. Therefore, each of the three modules of
							#VC101 by IVCA will be held in Mumbai (June 1), Bengaluru (June
							15) and New Delhi (July 6).
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Democratise Venture Capital Learning{" "}
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							The sector is witnessing a meteoric rise of funds and we at IVCA
							are aiming #VC101 to be available across the spectrum - First-Time
							Fund Managers (FTFMs), Micro VCs, Corporate Venture Capitals
							(CVCs), and active Family Offices and not restricting to only our
							members. Furthermore, by organising in-person learning via our
							sessions planned in Mumbai, Bengaluru and New Delhi – we intend to
							democratise the culture of learning and ensure maximum
							participation for venture funds from across the country.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								#VC101 Club and future engagements{" "}
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							Once you enrol, you are eligible to be a part of the exclusive
							#VC101 Club - a community of like-minded fund managers. We will
							continue to exchange notes with the participants and engage in
							other Masterclasses on tech and regulatory landscapes, which will
							be crafted especially for this audience from the who’s who of the
							VC/PE Ecosystem. Also, there will be smaller meetups planned in
							the coming months.
						</Text>
					</UnorderedList>
					<Text variant="blogAnswer" pb="20px">
						Overall, we are excited to launch #VC101 by IVCA to help new fund
						managers meander through a complex time and space in investing
						history and to be empowered to have a winning strategy for their
						investment decisions. We are happy to discuss more, receive feedback
						and respond to queries related to the programme. Shoot us an email
						at{" "}
						<Link
							as="a"
							href="mailto:amit.pandey@ivca.in"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							amit.pandey@ivca.in
						</Link>{" "}
						/{" "}
						<Link
							as="a"
							href="mailto:sunitha@ivca.in"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							sunitha@ivca.in
						</Link>{" "}
						or meet us when traveling to New Delhi or Bengaluru next. To apply,
						click{" "}
						<Link
							as="a"
							href="https://www.ivca.in/vc-101"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							here
						</Link>
						.
					</Text>
				</Box>
			</Flex>
			<Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
			<Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
				<Heading variant="blogQuestion" fontStyle="normal" as="span">
					#TheContext by IVCA{" "}
				</Heading>
				– features opinion makers from the alternate investing industry with
				strong focus on India as investment destination. Watch this space for
				viewpoints on investment themes, emerging trends, economic analysis and
				latest industry insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with &nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default VC101Blog;
